import { scrollToId } from '@/newcar/ui/contract/function';

// 指定のIDまでスクロールする
export default function scrollToField(id: string, height?:number): void {
  scrollToId(id, height);
}
